var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden"},[_c('section',{staticClass:"package-section pb-5 pt-5",attrs:{"id":"questions"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-lg-12"},[_c('accordian',{attrs:{"id":"accordion-1","contents":_vm.contents}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }